import { useNavigate,  } from "react-router-dom";
import { useSelector } from "react-redux";

import { PayBtn } from "./elements/pay-btn";


const statuses = [
    { id: 1, status: 'Прийнято', className: 'text-primary' },
    { id: 2, status: 'Готується', className: 'text-info' },
    { id: 3, status: 'Готово', className: 'text-success' },
    { id: 5, status: 'Рахунок', className: 'text-success' }
];


export const OrdersList = ({orders, table}) => {
    const navigate = useNavigate();
    const { payConfirmation, payment } = useSelector(state => state.header.settings);console.log(payment);

    const handlePayClick = (values) => {

        return navigate(`/checkout?tb=${table}`, {state: {isSimplePay: true, payment: values.method, cartId: values.orderId}});
    }

    const content = orders.map(order => {
        const { dishes } = order;
        console.log(checkProducts(order.dishes));
        return (
            <>
                <tbody>
                    <tr key={order.id}>
                        <td colSpan={5}>Замовлення: {order.id}</td>
                    </tr>
                    {dishes.map(dish => {
                        const modificators = dish?.modificators 
                        ? dish.modificators.reduce((acc, arr) => acc + parseFloat(arr.price), 0).toFixed(2) 
                        : 0;
                        const foundStatus = statuses.find(status => status.id === Number(dish.status));

                        return (
                            <tr key={dish.id}>
                                <td>{dish.name}</td>
                                <td className={foundStatus && order.accessStatus ? `${foundStatus.className} fw-bold` : 'text-secondary fw-bold'}>
                                    {foundStatus && order.accessStatus ? foundStatus.status : 'Очікує'}
                                </td>
                                <td className="text-end">{dish.qty}</td>
                                <td className="text-end">{dish.price}</td>
                                <td className="text-end">{dish.price * dish.qty} {modificators > 0 ? `(+${modificators})` : ''}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <th scope="col" colSpan={4} className="text-end">До сплати</th>
                        <th scope="col" colSpan={2} className="text-end">{order.amount}</th>
                    </tr>
                    {order.accessStatus && payConfirmation && Number(payConfirmation) !== 0 && checkProducts(order.dishes) &&
                        <PayBtn props={{payment, orderId: order.id, paid: order.paid}} onHandleClick={handlePayClick}/>
                    }
                </tbody>
            </>
        );
    }).filter(Boolean);


    return (
       <>
            <table className="table mb-5">
                <thead>
                    <tr>
                        <th scope="col" className="">Товар</th>
                        <th scope="col" className="">Статус</th>
                        <th scope="col" className="">Кількість</th>
                        <th scope="col" className=" text-end">Ціна</th>
                        <th scope="col" className=" text-end">Cума</th>
                    </tr>
                </thead>
                {content}
            </table>
       </>
    )
}

function checkProducts(products) {
    console.log(products);
    return products.every(product => {
        if (Number(product.gravimetric) === 1) {
            return Number(product.status) === 5;
        } else {
            return Number(product.status) === 2 || Number(product.status) === 5;
        }
    });
}